export default __webpack_public_path__ + "static/media/251032.00925c08.png";